import React, { useEffect } from 'react';
import steps from './steps';
import OtpPage from '../../../components/OtpPage/OtpPage';
import { navigate } from 'gatsby';
import FormikWizard from 'formik-wizard';
import { isLoggedIn } from '../../../common/utils/cookie-utils';
import AskMobileNo from '../../../components/ForgotPassword/AskMobileNo';
import {
  createPassword as createPasswordApi,
  login,
  getUserProfile
} from '../../../common/constants/api';
import { setAuthCookies as setToken } from '../../../common/utils/cookie-utils';
import config from '../../../../data/SiteConfig';
import globalUserData from '../../../common/userData/globalUserData';

let user = 'rm';
function FormWrapper({
  children,
  isLastStep,
  status,
  values,
  setStatus,
  goToPreviousStep,
  canGoBack,
  wizard,
  err,
  actionLabel
}) {
  return (
    <div>
      {console.log(user)}
      {wizard.step.id == 'otp' ? (
        <OtpPage
          wizard={wizard}
          values={values}
          previousStep={goToPreviousStep}
          user={user}
        />
      ) : wizard.step.id == 'askMobile' ? (
        <AskMobileNo wizard={wizard} values={values} user={user} />
      ) : (
        children
      )}
    </div>
  );
}
const index = props => {
  // const [err, setErr] = useState('');
  const handleSubmit = React.useCallback(values => {
    return createPassword(values.confirmPassword, values.askMobile);
  }, []);
  let createPassword = async (sectionValues, formValues) => {
    if (sectionValues.password) {
      try {
        await createPasswordApi(
          sectionValues.password,
          config.forgotPassTempToken.token
        );
        try {
          let res = await login({
            username: formValues.email,
            userType: 1,
            password: sectionValues.password
          });
          console.log(res);
          let [id, token, username, userType] = [
            res.id,
            res.token,
            res.username,
            res.userType
          ];
          await setToken({ id, token, username, userType });
          let resp = await getUserProfile();
          localStorage.setItem('userData', JSON.stringify(resp));
          // globalUserData.userData = resp;
          navigate('/app/dashboard');
        } catch (err) {
          return err.response?.data;
          // throw new Error(err.response.data.message);
        }
      } catch (err) {
        //console.log(err)
        return err.response?.data;
        // throw new Error(err.response.data.message);
      }
    }
  };
  useEffect(() => {
    isLoggedIn() ? navigate('/app/dashboard') : null;
  });
  return (
    <FormikWizard
      steps={steps}
      // errState={setErr}
      onSubmit={handleSubmit}
      render={FormWrapper}
    />
  );
};
export default index;
